import { render, staticRenderFns } from "./TravelerRegister.vue?vue&type=template&id=381618b0&"
import script from "./TravelerRegister.vue?vue&type=script&lang=js&"
export * from "./TravelerRegister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports